import { createContext } from "react";
//#region src/contexts/drawer.ts
const DrawerContext = createContext({ position: "bottom" });
//#endregion
export { DrawerContext };

//# sourceMappingURL=drawer.js.map